const normalize = value => String(value || '')
  .toLocaleLowerCase('it-IT')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[’']/g, "'")
  .trim();

export const practiceDocumentDefinitions = [
  { key: 'identityCard', label: 'Carta d’identità', area: 'Cliente', aliases: ["Carta d'identità"] },
  { key: 'drivingLicense', label: 'Patente', area: 'Cliente' },
  { key: 'cai', label: 'Constatazione amichevole', area: 'Sinistro', aliases: ['CAI'] },
  { key: 'accidentPhotos', label: 'Fotografie del sinistro', area: 'Sinistro', aliases: ['Fotografie iniziali'] },
  { key: 'detailsExchange', label: 'Scambio generalità', area: 'Sinistro', authorityOnly: true },
  { key: 'accidentReport', label: 'Rapporto d’incidente', area: 'Sinistro', authorityOnly: true, aliases: ["Rapporto d'incidente", 'Verbale delle autorità'] },
  { key: 'registration', label: 'Libretto', area: 'Veicolo', aliases: ['Carta di circolazione'] },
  { key: 'repairEstimate', label: 'Preventivo di riparazione', area: 'Veicolo', aliases: ['Preventivo di parte'] },
  { key: 'appraisal', label: 'Perizia', area: 'Veicolo', aliases: ['Perizia del veicolo'] },
  { key: 'creditAssignment', label: 'Cessione del credito', area: 'Veicolo' },
  { key: 'repairPhotos', label: 'Fotografie dei lavori', area: 'Veicolo', multiplePhotos: true, aliases: ['Documentazione fotografica dei lavori'] },
  { key: 'demolitionPhotos', label: 'Fotografie del veicolo da demolire', area: 'Veicolo', multiplePhotos: true },
  { key: 'repairInvoice', label: 'Fattura del riparatore', area: 'Veicolo', aliases: ['Fattura di riparazione'] },
  { key: 'cessation', label: 'Annotata cessazione', area: 'Veicolo', aliases: ['Annotata cessazione dalla circolazione'] },
  { key: 'emergencyRoom', label: 'Pronto soccorso', area: 'Medico' },
  { key: 'medicalVisit', label: 'Visita medica', area: 'Medico' },
  { key: 'diagnosticExam', label: 'Esame diagnostico', area: 'Medico' },
  { key: 'therapy', label: 'Terapia', area: 'Medico' },
  { key: 'medicalInvoice', label: 'Fattura medica', area: 'Medico' },
  { key: 'medicalLegalReport', label: 'Perizia medico-legale di parte', area: 'Medico', aliases: ['Relazione medico-legale di parte', 'Perizia medico legale di parte'] },
  { key: 'deathCauseCertificate', label: 'Certificato delle cause di morte', area: 'Pratica mortale', aliases: ['Certificato causa morte'] },
  { key: 'heirsDeclaration', label: 'Dichiarazione sostitutiva dell’atto di notorietà relativa agli eredi', area: 'Pratica mortale', aliases: ['Atto notorio sostitutivo eredi', 'Dichiarazione eredi'] },
  { key: 'historicalFamilyResidence', label: 'Stato di famiglia storico con residenza', area: 'Pratica mortale', aliases: ['Storico stato di famiglia con residenza'] },
  { key: 'criminalFile', label: 'Fascicolo penale', area: 'Pratica mortale' },
  { key: 'damageClaim', label: 'Richiesta danni', area: 'Lettere e moduli', aliases: ['Richiesta risarcimento', 'Messa in mora'] },
  { key: 'letter', label: 'Lettera o modulo', area: 'Lettere e moduli' },
  { key: 'other', label: 'Altro', area: 'Altro' }
];

export const documentDefinition = key => practiceDocumentDefinitions.find(item => item.key === key);

export const documentMatchesDefinition = (document, definition) => {
  if (!document || !definition) return false;
  const description = normalize(document.descrizione);
  const names = [definition.label, ...(definition.aliases || [])].map(normalize);
  return names.some(name => description === name || description.startsWith(`${name} ·`) || description.startsWith(`${name} -`));
};

export const latestDocumentFor = (documents, definition) => [...(documents || [])]
  .filter(item => documentMatchesDefinition(item, definition))
  .sort((left, right) => new Date(right.creato_il || 0) - new Date(left.creato_il || 0))[0] || null;

